import dayjs from 'dayjs';
import { isNotEmpty } from '@lhb/func';

export interface LocxxTaskDetailItem {
  key: string;
  label: string;
  value: string;
}

export function getLocxxTaskEditableKeys() {
  return ['marketingPurposeName', 'areaRequirement', 'floorHeight', 'minFlowBottomLine', 'activityPeriodName', 'promotionDate', 'totalBudget', 'expectDropInDate'];
}

export function getPromotionDateValueProps(value: unknown) {
  const dates = Array.isArray(value) ? value : [];
  return {
    value: dates.length === 2 && dates.every((date) => isNotEmpty(date))
      ? [dayjs(dates[0] as string, 'YYYY-MM-DD'), dayjs(dates[1] as string, 'YYYY-MM-DD')]
      : undefined,
  };
}

export function buildLocxxTaskDetailItems(taskDetail: any, basicTaskInfo: any): LocxxTaskDetailItem[] {
  const marketingPurposeNameMap: Record<number, string> = { 6: '品牌宣传', 7: '获客', 8: '售卖' };
  const activityPeriodUnitMap: Record<number, string> = { 1: '日', 2: '周', 3: '月' };
  const assignAccounts = Array.isArray(taskDetail.assignAccounts) ? taskDetail.assignAccounts : [];
  const assignAccountNames = assignAccounts.map((account: any) => account?.name).filter(Boolean).join('、');
  return [
    { key: 'modelClusterName', label: '商圈', value: basicTaskInfo.modelClusterName || '-' },
    { key: 'targetAdress', label: '目标城市', value: basicTaskInfo.targetAdress || '-' },
    { key: 'manager', label: '开发人员', value: assignAccountNames || '-' },
    { key: 'marketingPurposeName', label: '营销目的', value: taskDetail.marketingPurposeName || marketingPurposeNameMap[taskDetail.marketingPurpose] || '-' },
    { key: 'areaRequirement', label: '面积范围', value: taskDetail.areaRequirementMin || taskDetail.areaRequirementMax ? `${taskDetail.areaRequirementMin || 0}~${taskDetail.areaRequirementMax || 0} ㎡` : '-' },
    { key: 'floorHeight', label: '层高要求', value: taskDetail.floorHeight ? `≥${taskDetail.floorHeight} m` : '-' },
    { key: 'minFlowBottomLine', label: '客流底线', value: taskDetail.minFlowBottomLine || taskDetail.minFlowBottomLine === 0 ? `${taskDetail.minFlowBottomLine} 人/天` : '-' },
    { key: 'activityPeriodName', label: '活动周期', value: taskDetail.activityPeriodCount ? `${taskDetail.activityPeriodCount}${activityPeriodUnitMap[taskDetail.activityPeriodUnit] || ''}` : '-' },
    { key: 'promotionDate', label: '活动日期', value: taskDetail.promotionDateStart && taskDetail.promotionDateEnd ? `${taskDetail.promotionDateStart} - ${taskDetail.promotionDateEnd}` : '-' },
    { key: 'totalBudget', label: '场地预算', value: taskDetail.totalBudget || taskDetail.totalBudget === 0 ? `${Number(taskDetail.totalBudget).toFixed(2)} 万元` : '-' },
    { key: 'expectDropInDate', label: '期望落位日期', value: taskDetail.expectDropInDate || '-' },
  ];
}
